import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    width: 100%;
    flex: 1;
    padding: 2rem;
    padding-bottom: 0;
    gap: .75rem;
    background: #f3f4f6;
    flex-direction: column;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb{
      background-color: rgb(0, 0, 0,0.2);
    }
    .disabled{
      pointer-events: none;
      opacity: 0.7;
    }
    .column{
      display: flex;
      width: 100%;
      align-items: center;
      gap: 1rem;
      font-weight: 400;
    }
`;
export const BoxSelect = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  .box--{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    .line-{
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      justify-content: space-between;
      .date{
        width: 10rem;
        border: 1px solid #1D86FF;
        background-color: transparent;
      }
    }
  }
  .list-{
    width: 20rem;
  }
  
`;
export const BtnSearch = styled.button`
    outline: none;
    border: none;
    display: flex;
    width: 3rem;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    color: #ffffff;
    background-color: #1D86FF;
    font-size: 1.5rem;

    .loader{
        display: flex;
        border: 2px solid #ffffff;
        border-radius: 50%;
        border-top: 2px solid #1d83e2;
        width: 2rem;
        height: 2rem;
        animation: spin 1.5s linear infinite;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  .area--cards{
    display: flex;
    width: 100%;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: center;
  }
  .area--table{
    display: flex;
    width: 100%;
    margin-top: 2rem;
    background-color: #ffffff;
    padding-bottom: 1rem;
    border-radius: 4px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  }
`;